var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('p',{staticClass:"MapLink"},[_c('a',{staticClass:"Btn sm bright",attrs:{"alt":_vm.label,"href":_vm.url,"rel":"noreferrer","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }